export const OPEN_CONVERSATION = 'app/LiveChat/OPEN_CONVERSATION';
export const CLOSE_CONVERSATION = 'app/LiveChat/CLOSE_CONVERSATION';

export const FETCH_ACTIVE_CONVERSATIONS_REQUEST =
  'app/LiveChat/FETCH_ACTIVE_CONVERSATIONS_REQUEST';
export const FETCH_ACTIVE_CONVERSATIONS_SUCCESS =
  'app/LiveChat/FETCH_ACTIVE_CONVERSATIONS_SUCCESS';
export const FETCH_ACTIVE_CONVERSATIONS_ERROR =
  'app/LiveChat/FETCH_ACTIVE_CONVERSATIONS_ERROR';

export const FETCH_ARCHIVED_CONVERSATIONS_REQUEST =
  'app/LiveChat/FETCH_ARCHIVED_CONVERSATIONS_REQUEST';
export const FETCH_ARCHIVED_CONVERSATIONS_SUCCESS =
  'app/LiveChat/FETCH_ARCHIVED_CONVERSATIONS_SUCCESS';
export const FETCH_ARCHIVED_CONVERSATIONS_ERROR =
  'app/LiveChat/FETCH_ARCHIVED_CONVERSATIONS_ERROR';

export const FETCH_CONVERSATION_MESSAGES_REQUEST =
  'app/LiveChat/FETCH_CONVERSATION_MESSAGES_REQUEST';
export const FETCH_CONVERSATION_MESSAGES_SUCCESS =
  'app/LiveChat/FETCH_CONVERSATION_MESSAGES_SUCCESS';
export const FETCH_CONVERSATION_MESSAGES_ERROR =
  'app/LiveChat/FETCH_CONVERSATION_MESSAGES_ERROR';

export const ON_MESSAGE_SENT_RECEIVE = 'app/LiveChat/ON_MESSAGE_SENT_RECEIVE';

export const MARK_MESSAGE_READ_LOCALLY =
  'app/LiveChat/MARK_MESSAGE_READ_LOCALLY';
export const ON_MESSAGE_READ_RECEIVE = 'app/LiveChat/ON_MESSAGE_READ_RECEIVE';

export const SET_CREATING_CONVERSATION =
  'app/LiveChat/SET_CREATING_CONVERSATION';
export const ON_CONVERSATION_CREATED_RECEIVE =
  'app/LiveChat/ON_CONVERSATION_CREATED_RECEIVE';
export const SET_GUEST_INTERLOCUTOR_ID =
  'app/LiveChat/SET_GUEST_INTERLOCUTOR_ID';

export const SET_ARCHIVING_CONVERSATION =
  'app/LiveChat/SET_ENDING_CONVERSATION';
export const ON_CONVERSATION_ARCHIVED_RECEIVE =
  'app/LiveChat/ON_CONVERSATION_ENDED_RECEIVE';

export const SET_NAVIGATOR_UNAVAILABLE =
  'app/LiveChat/SET_NAVIGATOR_UNAVAILABLE';

export const SET_CURRENT_NAVIGATOR_UNAVAILABLE =
  'app/LiveChat/SET_CURRENT_NAVIGATOR_UNAVAILABLE';

export const ON_LIVE_CHAT_SETUP_FETCHED_RECEIVE =
  'app/LiveChat/ON_LIVE_CHAT_SETUP_FETCHED_RECEIVE';

export const SET_FETCHING_LIVE_CHAT_SETUP =
  'app/LiveChat/SET_FETCHING_LIVE_CHAT_SETUP';

export const FETCH_NAVIGATOR_HELPING_MATERIALS_REQUEST =
  'app/LiveChat/FETCH_NAVIGATOR_HELPING_MATERIALS_REQUEST';
export const FETCH_NAVIGATOR_HELPING_MATERIALS_SUCCESS =
  'app/LiveChat/FETCH_NAVIGATOR_HELPING_MATERIALS_SUCCESS';
export const FETCH_NAVIGATOR_HELPING_MATERIALS_ERROR =
  'app/LiveChat/FETCH_NAVIGATOR_HELPING_MATERIALS_ERROR';

export const ON_CURRENT_SCREEN_TITLE_CHANGED =
  'app/LiveChat/ON_CURRENT_SCREEN_TITLE_CHANGED';

export const GENERATE_CONVERSATION_TRANSCRIPT_REQUEST =
  'app/LiveChat/GENERATE_CONVERSATION_TRANSCRIPT_REQUEST';

export const SET_CALLING_OUT_NAVIGATOR =
  'app/LiveChat/SET_CALLING_OUT_NAVIGATOR';

export const SET_CALL_OUT_NAVIGATOR_UNLOCK_TIME =
  'app/LiveChat/SET_CALL_OUT_NAVIGATOR_UNLOCK_TIME';

export const SET_WAITING_FOR_NAVIGATOR =
  'app/LiveChat/SET_WAITING_FOR_NAVIGATOR';

export const SET_CANCELLING_CALL_OUT = 'app/LiveChat/SET_CANCELLING_CALL_OUT';

export const UPDATE_CONVERSATION_TRANSCRIPT =
  'app/LiveChat/UPDATE_CONVERSATION_TRANSCRIPT';

export const SET_HAS_ASSIGNED_NAVIGATORS =
  'app/LiveChat/SET_HAS_ASSIGNED_NAVIGATORS';
